import React from 'react';

import './ForumMenu.scss';

class ForumMenu extends React.PureComponent {
  renderMenuItems = () => {
    return this.props.langs.surgery.map((surgery) => {
      const activeClass = surgery.id === this.props.surgeryActive ? "active" : "";

      return (
        <div
          className="col-2"
          key={surgery.id}
          id={surgery.id}
          onClick={this.props.handleSurgeryClick.bind(this)}>
          <div className={`forumMenu_item ${activeClass}`}>
            <i className={`llc-${surgery.icon}`}/>
            <div className="forumMenu_title"> {surgery.id === 2 ? "Laserová a estetická medicína" : surgery.name}</div>
          </div>
        </div>
      )
    });
  };

  renderSubmenuItems = () => {
    if (this.props.surgeryActive === 0) return <span/>;

    const surgery = this.props.langs.surgery.find(
      sur => sur.id === parseInt(this.props.surgeryActive)
    );

    return surgery.procedures.map(proc => {
      return <li
        key={proc.id}
        id={proc.id}
        onClick={this.props.handleProcedureClick.bind(this)}
        className={proc.id === this.props.procedureActive ? "active" : ""}
      >{proc.name}</li>
    })
  };

  render() {
    const activeToAll = this.props.surgeryActive === 0 ? "active" : "";

    return (
      <section className="forumMenu">
        <div className="forumMenu_top">
          <div className="container">
            <div className="row">
              <div className="col-1" id={0} onClick={this.props.handleSurgeryClick.bind(this)}>
                <div className={`forumMenu_item ${activeToAll}`}>
                  <i className="llc-select-all"/>
                  <div className="forumMenu_title">Vše</div>
                </div>
              </div>
              {this.renderMenuItems()}
            </div>
          </div>
        </div>
        <div className="forumMenu_subMenu_wrap">
          <div className="container">
            <ul className="forumMenu_subMenu ul clearfix">
              {this.renderSubmenuItems()}
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

export default ForumMenu;


// WEBPACK FOOTER //
// ./src/components/Forum/ForumMenu/ForumMenu.js